import dayjs from "dayjs";
import { sortGrid } from "../sortGrid";

const adaptUserReport = (userReport: IUserReport[]) => {
	const flatData: any = {};

	userReport.forEach((userReport: IUserReport) => {
		const generateFlatData = () => {
			// new row, create a new object
			const key = dayjs()
				.month(userReport.month - 1)
				.format("MMM");

			if (flatData[`k_${userReport.user_id}`] === undefined) {
				flatData[`k_${userReport.user_id}`] = {};

				flatData[`k_${userReport.user_id}`]["name"] = userReport.user_name;
				flatData[`k_${userReport.user_id}`]["user_name"] = userReport.user_name;
				flatData[`k_${userReport.user_id}`]["user_id"] = userReport.user_id;
				flatData[`k_${userReport.user_id}`]["user_uuid"] = userReport.user_uuid;
				flatData[`k_${userReport.user_id}`]["user_role"] = userReport.user_role;
				flatData[`k_${userReport.user_id}`]["store_name"] =
					userReport.store_name;
				flatData[`k_${userReport.user_id}`]["great_conversation_store_id"] =
					userReport.great_conversation_store_id;
				flatData[`k_${userReport.user_id}`]["observationform"] =
					userReport.observationform;
				flatData[`k_${userReport.user_id}`]["graded"] = userReport.graded_count;
				flatData[`k_${userReport.user_id}`]["complete"] =
					userReport.complete_count;
			}

			flatData[`k_${userReport.user_id}`][key] = {
				complete: userReport.complete_count,
				compliant: userReport.compliant_count,
				month: userReport.month,
				graded: userReport.graded_count
			};
		};
		generateFlatData();
	});

	// Flatten the data
	const data = Object.keys(flatData).map((key) => flatData[key]);

	sortGrid(data, "name");

	return data;
};

export default adaptUserReport;
